/**
 * 라우트 경로 상수
 */

export const ROUTES = {
  HOME: '/',

  // 교회 소개
  CHURCH_INTRO: {
    ABOUT: '/church/about',
    GREETING: '/church/greeting',
    WORSHIP: '/church/worship',
    LOCATION: '/church/location',
  },

  // 설교 영상
  SERMON: {
    SUNDAY_MORNING: '/sermon/sunday-morning',
    SUNDAY_EVENING: '/sermon/sunday-evening',
    WEDNESDAY: '/sermon/wednesday',
    DAWN: '/sermon/dawn',
    FRIDAY: '/sermon/friday',
  },

  // 교회학교
  SUNDAY_SCHOOL: {
    INTRO: '/sunday-school/intro',
    BOARD: '/sunday-school/board',
  },

  // 부서 안내
  DEPARTMENT: {
    HALLELUJAH_CHOIR: '/department/hallelujah-choir',
    WIRYE_CHOIR: '/department/wirye-choir',
    PRAISE_TEAM: '/department/praise-team',
    AGAPE: '/department/agape',
  },

  // 새가족
  NEW_FAMILY: '/new-family',

  // 커뮤니티
  COMMUNITY: {
    NEWS: '/community/news',
    GALLERY: '/community/gallery',
    BULLETIN: '/community/bulletin',
  },

  // 관리자
  ADMIN: {
    LOGIN: '/admin/login',
    DASHBOARD: '/admin/dashboard',
    SLIDER: '/admin/slider', // 주석처리됨 - 정적 이미지 사용
    BOARD: '/admin/board', // 사용하지 않음
    BOARD_SUNDAY_SCHOOL: '/admin/board/sunday-school',
    BOARD_NEWS: '/admin/board/news',
    BOARD_GALLERY: '/admin/board/gallery',
    BOARD_BULLETIN: '/admin/board/bulletin',
  },
} as const;
